export default class Tag {
  id: number
  name: string
  type: string
  parent_id: number

  constructor(json: any) {
    this.id = json.id ?? 0
    this.name = json.name ?? ""
    this.type = json.type ?? ""
    this.parent_id = json.parent_id ?? ""
  }
}
